import Datetime from 'react-datetime'; // https://www.npmjs.com/package/react-datetime
import 'react-datetime/css/react-datetime.css';
import './datetime.css';

export default Datetime.default || Datetime;